<template>
  <div class="plan-upload">
    <el-card class="box-card" header='方案上传'>
      <div class="upload-area">
        <el-upload class="upload-demo" ref="upload" :show-file-list="false" action="/api/file/upload" :before-upload="beforeUpload" :disabled="disabled" :on-exceed="handleExceed" :limit="1" :on-success="handleSuccess" name="files" :data='{"type":"project"}'>
          <el-button type="success" :disabled='disabled'>+ 上传文件</el-button>
          <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
          <div slot="tip" class="el-upload__tip ext-info">支持扩展名: .rar .zip .doc .docx .xls .xlsx .jpg…</div>
        </el-upload>
        <div class="file" v-for="(file,index) in fileList " :key="index">
          <div class="file-left" @click="handlePreview(file)">

            <img v-if="file.suffName.indexOf('xls')>-1" src="../../assets/img/xls.png" alt="" srcset="">
            <img v-else-if="file.suffName.indexOf('ppt')>-1" src="../../assets/img/ppt.png" alt="" srcset="">
            <img v-else-if="imgs.includes(file.suffName)" src="../../assets/img/jpg.png" alt="" srcset="">
            <img v-else-if="file.suffName.indexOf('pdf')>-1" src="../../assets/img/pdf.png" alt="" srcset="">
            <img v-else-if="['rar','zip'].includes(file.suffName)" src="../../assets/img/zip.png" alt="" srcset="">
            <img v-else src="../../assets/img/doc.png" alt="" srcset="">
            <span class="file-name">{{file.fileName}}</span>
          </div>
          <div class="tags">
            <el-tag v-if="file.tag" size="small" type='danger' effect="dark" :closable='!disabled' :disable-transitions="false" @close="handleClose(file)">
              {{file.tag}}
            </el-tag>
            <el-input class="input-new-tag" v-if="fileId == file.uuid&&!file.tag &&!disabled" v-model="tagName" :ref="'saveTagInput'+file.uuid" size="mini" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
            </el-input>
            <el-button v-if="fileId != file.uuid &&!file.tag &&!disabled" class="button-new-tag" type="primary" plain size="mini" @click="showInput(file.uuid)">+添加标签</el-button>
          </div>
          <i :class="{'el-icon-close':!disabled,'el-icon-circle-check':disabled}" @click="removeFile(file)"></i>
        </div>
      </div>
    </el-card>
    <el-dialog title="文件预览" :visible.sync="fileVisible" width="90%" top='10px' @close="fileVisible=false">
      <div style="  display: flex;justify-content: center;">
        <iframe :src="src" frameborder="0" style="width: 100%; height:80vh "></iframe>
      </div>
    </el-dialog>
    <el-image-viewer v-if="imgVisible" :on-close="()=>{imgVisible=false,filepaths=''}" :url-list="[filepaths]" />
  </div>
</template>

<script>
import * as fileApi from '../../api/fileAPI'
import * as projectApi from '../../api/projectAPI'
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
  components: {
    ElImageViewer
  },
  props: {
    'disabled': {
      type: Boolean,
      default: true
    },
    // 'fileList': {
    //   type: Array,
    //   default: function () {
    //     return []
    //   }
    // },
  },
  data() {
    return {
      fileList: [],
      fileVisible: false,
      imgVisible: false,
      src: '',
      imgs: ['jpg', 'jpeg', 'png', 'gif', 'bmp'],
      filepaths: '',
      tags: [],
      addTagsFlag: false,
      tagName: '',
      fileId: '',
    };
  },
  computed: {

  },
  watch: {

  },
  created() {

  },
  async mounted() {
    this.projectId = this.$route.params.id
    let res = await projectApi.qryProjectFile(this.projectId, 0)
    if (res.flag) {
      this.fileList = res.data
    }

  },
  methods: {
    handleSuccess(res, file, fileList) {
       this.loading.close()
      file.status = file.status
      let projectId = this.$route.params.id
      if (res.flag) {
        this.$message.success('上传成功')
        this.fileList.push({ projectId, uuid: res.data[0], fileName: file.name, tag: '实施方案', suffName: file.name.substring(file.name.lastIndexOf('.') + 1), type: 0 })
      } else {
        this.$message.error(res.message)
      }
      console.log("handleSuccess", this.fileList);
    },
    async handlePreview(file) {
      console.log(file);
      let fileName = file.fileName
      let uuid = file.uuid
      let suffName = fileName.substring(fileName.lastIndexOf('.') + 1)
      console.log('预览pdf', fileName, suffName)
      let offices = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf']
      if (!offices.includes(suffName) && !this.imgs.includes(suffName) && 'txt' != suffName) {

        return
      }
      let res = await fileApi.preview({ uuid, suffName, fileName })
      if (offices.includes(suffName)) {
        let blob = new Blob([res], { type: 'application/pdf' })
        let href = URL.createObjectURL(blob)
        console.warn(href)
        this.src = href
        // this.src = `./pdf/web/viewer.html?file=${encodeURIComponent(href)}`
        //window.open(`./pdf/web/viewer.html?file=${encodeURIComponent(href)}`);
        //this.src = this.getObjectURL(res)
        this.fileVisible = true
      } else if (this.imgs.includes(suffName)) {
        let blob = new Blob([res])
        let href = URL.createObjectURL(blob)
        console.warn(href)
        this.filepaths = href
        this.imgVisible = true
      } else if ('txt' == suffName) {
        console.log('txt', res);
        let blob = new Blob([res], { type: 'text/plain' })
        let href = URL.createObjectURL(blob)
        console.warn(href)
        this.src = href
        this.fileVisible = true

      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    removeFile(file) {
      if (this.disabled) return
      return this.$confirm(`确定移除 ${file.fileName}？`).then(() => {
        this.$refs.upload.uploadFiles= []
        this.fileList = []
      })

    },
    handleClose(file, tag) {//删除标签
      console.log('handleClose', file, tag);
      //file.tags.splice(file.tags.indexOf(tag), 1);
      file.tag = ''
    },

    showInput(id) {//点击添加标签按钮
      this.addTagsFlag = true;
      this.fileId = id
      this.$nextTick(_ => {
        console.log("showInput", this.$refs, this.$refs.saveTagInput1);
        this.$refs['saveTagInput' + id][0].$refs.input.focus();
      });
    },

    handleInputConfirm() {//输入标签提交
      console.log('handleInputConfirm');
      let tagName = this.tagName;
      if (tagName) {
        // this.fileList.find(f => f.id == this.fileId).tags.push(tagName)
        this.fileList.find(f => f.uuid == this.fileId).tag = tagName
      }
      this.fileId = ''
      this.addTagsFlag = false;
      this.tagName = '';
    },
    beforeUpload(file) {
      console.log("beforeUpload", this.fileList.length);
      if (this.fileList.length > 0) {
        this.$message.error("实施方案只能上传一个文件");
        return false
      }
       this.loading = this.$loading({
        target: '.container',
        lock: true,
        text: '拼命加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.3)'
      });
    }


  },
};
</script>

<style  lang="less">
.plan-upload {
  .el-card {
    border: none;
    box-shadow: none;
    border-radius: 0;
    .el-card__header {
      padding: 20px 0;
      margin: 0 40px;
      padding-left: 20px;
      position: relative;
      &::before {
        position: absolute;
        content: "";
        width: 4px;
        height: 20px;
        background: #346aff;
        opacity: 1;
        display: block;
        left: 0px;
        top: 20px;
      }
    }
    .el-card__body {
      padding-top: 0;
      .upload-area {
        margin: 20px;
        padding: 20px;
        border: 1px solid #dfdfe1;
        border-radius: 5px;
        display: flex;
        flex-direction: column;

        .ext-info {
          font-size: 12px;
          color: #a6aab8;
          padding: 20px 0;
        }
        .file {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;
          .file-left {
            cursor: pointer;
            display: flex;
            align-items: center;
            width: 240px;

            img {
              width: 20px;
            }
            .file-name {
              margin-left: 10px;
              font-size: 14px;
              color: #606266;
            }
          }
          .tags {
            .el-tag + .el-tag {
              margin-left: 10px;
            }
            .button-new-tag {
              margin-left: 10px;
              // height: 32px;
              line-height: 22px;
              padding-top: 0;
              padding-bottom: 0;
              font-size: 12px;
            }
            .input-new-tag {
              width: 90px;
              margin-left: 10px;
              vertical-align: bottom;
            }
          }
          i {
            font-size: 18px;
          }
          > .el-icon-close {
            cursor: pointer;
            color: #606266;
          }
          .el-icon-circle-check {
            color: #67c23a;
          }
        }
      }
    }
  }
  .el-dialog__body {
    padding: 0 20px;
  }
}
</style>
